import React, { ReactNode } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import Button from './Button';

interface ComponentProps {
  isOpen?: boolean;
  onClose: (confirm: boolean) => void;
  messages?: string[] | ReactNode;
  useList?: boolean;
}

const ConfirmDialog: React.FC<ComponentProps> = ({ isOpen = false, messages = [], onClose, useList = true }) => {
  const getContent = () => {
    if (Array.isArray(messages)) {
      return useList ? (
        <ul>
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      ) : (
        <p>{messages.join(' ')}</p>
      );
    }
    return messages;
  };

  const content = getContent();

  return (
    <Modal isOpen={isOpen} data-cy="appointments-confirm-dialog">
      <ModalHeader className="bg-success text-white">Confirmation Required</ModalHeader>
      <ModalBody>
        {useList && (
          <div className="mb-4 pb-2 border-2 border-bottom border-success">
            Please be aware of the following details...
          </div>
        )}
        {content}
      </ModalBody>
      <ModalFooter className="align-items-center flex-column">
        <div className="mb-1">Would you like to continue?</div>
        <div>
          <Button
            size="sm"
            color="success"
            className="ps-4 pe-4 me-2"
            onClick={() => onClose(true)}
            data-cy="confirm-dialog-confirm-button"
          >
            Yes
          </Button>
          <Button size="sm" className="ps-4 pe-4" onClick={() => onClose(false)} data-cy="confirm-dialog-deny-button">
            No
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDialog;
